'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkCheckedListItem.module.css';

export function DevlinkCheckedListItem({ as: _Component = _Builtin.Block, text = 'This is some text inside of a div block.' }) {
  return (
    <_Component className={_utils.cx(_styles, 'ht-checked-item')} tag="div">
      <_Builtin.Image
        className={_utils.cx(_styles, 'ht-check-icon')}
        loading="lazy"
        width="auto"
        height="auto"
        alt=""
        src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/65f887b831c0bc4c3529a8ab_check-teal.svg"
      />
      <_Builtin.Block className={_utils.cx(_styles, 'ht-checked-item-text')} tag="div">
        {text}
      </_Builtin.Block>
    </_Component>
  );
}
